interface Props {
  title: string;
  description: string;
  summary?: string;
  image?: string;
  imageAlt?: string;
}

const MedicineDictionary = (props: Props) => {
  return (
    <div className='flex items-center justify-between gap-[24px]'>
      <div className='flex flex-col items-baseline border border-gray-200'>
        <h3 className='typography-ui-15m mb-[2px] text-left text-gray-400'>{props.description}</h3>
        <h4 className='typography-ui-17sb mb-[8px] text-left text-gray-900'>{props.title}</h4>
        <span className='typography-ui-15m line-clamp-3 h-[68px] overflow-ellipsis text-left text-gray-400'>
          {props.summary}
        </span>
      </div>
      {props.image && (
        <div className='flex max-h-[72px] min-h-[72px] min-w-[72px] max-w-[72px] items-center justify-center rounded-[8px] border border-gray-30 border-solid bg-white'>
          <img
            src={props.image}
            alt={props.imageAlt}
            className='box-border h-auto w-full rounded-[8px] object-contain'
          />
        </div>
      )}
    </div>
  );
};

export default MedicineDictionary;
